<h1 mat-dialog-title>Add a new property name</h1>
<mat-dialog-content>
  <p>Please enter a unique name for the new property.</p>
  <form id="add-form" [formGroup]="form" (ngSubmit)="onConfirm()">
    <mat-form-field class="col-12">
      <mat-label>Property Name</mat-label>
      <input matInput formControlName="propertyName" cdkFocusInitial />
      @if (propertyName.hasError('required')) {
        <mat-error>Name is required.</mat-error>
      }
      @if (propertyName.hasError('propertyExists')) {
        <mat-error>This name already exists.</mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button type="button" mat-button (click)="onCancel()">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    type="submit"
    form="add-form"
    cdkFocusInitial
    [disabled]="!form.valid"
  >
    Add Property
  </button>
</mat-dialog-actions>
